import modelReducer from "../../reducers/modelReducer";
import ButtonPanel, { ButtonDefinition } from "../buttonPanel";
import { MenuProps } from "./menuTypes";
import { Node, NodeType } from "../../types/Graph";
import { useEffect } from "react";
import { dedupeNodes } from "../../util/ModelUtil";

const ModelTransformsMenu = ({ model, setModel, selection }: MenuProps) => {
  const loadModelCallback = () => {
    const newModelJSON = prompt("Model?") ?? "";
    const newModel = JSON.parse(newModelJSON);
    setModel(newModel);
  };
  const copyModelCallback = () => {
    const modelJSON = JSON.stringify(model);
    navigator.clipboard.writeText(modelJSON);
    alert("Copied model to clipboard");
  };
  const saveModelCallback = () => {
    const modelJSON = JSON.stringify(model);
    const blob = new Blob([modelJSON], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "model.json";
    link.click();
  };

  const modelMenuButtons: ButtonDefinition[] = [
    { label: "load model", callback: loadModelCallback },
    { label: "copy model", callback: copyModelCallback },
    { label: "save model", callback: saveModelCallback },
  ];

  const description = "Buttons to load and save models";
  return (
    <ButtonPanel
      buttons={modelMenuButtons}
      title="Model Transform Modeling Abstractions"
      description={description}
    />
  );
};

export default ModelTransformsMenu;
